import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';

const Dt = () => {
	return <CommonOperationScreen operationName="DT" buttonLabel="Mark DT Complete" />;
};

export default Dt;
